var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-gy",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#399408",
    d: "M2 0h510v512H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.1 0c-.6 0 495.7 257.6 495.7 257.6L0 511.7.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde08",
    d: "M.2 21.5C3 21.5 447.5 254 445 256.2L1.5 494.2.2 21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5.8c1.5 0 232.8 257 232.8 257L1.5 508.8V.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M.2 36.2C1.6 20.2 209 258.5 209 258.5L.2 481.8V36.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGy);
export default __webpack_public_path__ + "static/media/gy.e28d1b4b1a434168df636b352b5616da.svg";
export { ForwardRef as ReactComponent };